import { Controller } from "@hotwired/stimulus"

const DRAG_OVER_CLASSES = ["border-text-action-default", "bg-fill-elevation-level-1"]

export default class extends Controller {
  static targets = ["input", "placeholder", "filled", "fileName", "previewImage", "status"]
  static values = {
    pendingLabel: String,
    savedLabel: String,
    autoSubmit: { type: Boolean, default: true },
  }

  preview() {
    const files = Array.from(this.inputTarget.files)
    const file = files[0]
    if (!file) return

    this.fileNameTarget.textContent = files.map((chosen) => chosen.name).join(", ")
    this.placeholderTarget.classList.add("hidden")
    this.filledTarget.classList.remove("hidden")

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = this.pendingLabelValue
      this.statusTarget.classList.remove("text-message-heading-success")
      this.statusTarget.classList.add("text-text-tertiary")
    }

    if (this.hasPreviewImageTarget && file.type.startsWith("image/")) {
      const reader = new FileReader()
      reader.onload = (event) => {
        this.previewImageTarget.src = event.target.result
        this.previewImageTarget.classList.remove("hidden")
      }
      reader.readAsDataURL(file)
    }

    if (!this.autoSubmitValue) return

    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  replace(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  dragOver(event) {
    event.preventDefault()
    this.placeholderTarget.classList.add(...DRAG_OVER_CLASSES)
  }

  dragLeave(event) {
    if (event.currentTarget.contains(event.relatedTarget)) return
    this.placeholderTarget.classList.remove(...DRAG_OVER_CLASSES)
  }

  drop(event) {
    event.preventDefault()
    this.placeholderTarget.classList.remove(...DRAG_OVER_CLASSES)

    const accepted = Array.from(event.dataTransfer.files).filter((file) => this.fileMatchesAccept(file))
    const dropped = this.inputTarget.multiple ? accepted : accepted.slice(0, 1)
    if (dropped.length === 0) return

    const transfer = new DataTransfer()
    dropped.forEach((file) => transfer.items.add(file))
    this.inputTarget.files = transfer.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  fileMatchesAccept(file) {
    const accept = this.inputTarget.accept
    if (!accept) return true

    const patterns = accept.split(",").map((pattern) => pattern.trim()).filter(Boolean)
    return patterns.some((pattern) => {
      if (pattern.endsWith("/*")) return file.type.startsWith(pattern.slice(0, -1))
      if (pattern.startsWith(".")) return file.name.toLowerCase().endsWith(pattern.toLowerCase())
      return file.type === pattern
    })
  }
}
